<template>
  <router-link to="/user" tag="div" class="box has-cursor-pointer">
    <div class="is-flex">
      <h1 class="is-size-6 is-uppercase is-expanded">{{ role }}</h1>
      <h1 class="is-size-6 count">{{ totalDocs }}</h1>
    </div>
    <div class="has-text-centered" v-if="loading">
      <button class="button is-borderless is-loading"></button>
    </div>
  </router-link>
</template>
<script>
import http from "@/http";
export default {
  props: {
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      totalDocs: 0
    };
  },
  mounted() {
    let component = this;
    component.loading = true;
    http.post("/user/index", { role: component.role }).then(response => {
      component.loading = false;
      component.totalDocs = response.data.totalDocs;
    });
  }
};
</script>
<style lang="scss" scoped></style>
